import { GetComisionPagadas } from "../../../reducers/comisiones";
import * as actions from "../../../actions/comisiones";
import { Preview } from "../../../../types/IAction";

export interface ComisionesPagadasDispatcher {
  clearComision: () => Promise<Preview<void>>;
  getComisionesPagadas: (
    idEmpleado: number,
    fechaPago: string
  ) => Promise<Preview<GetComisionPagadas>>;
}

export const comisionesPagadasDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ComisionesPagadasDispatcher = dispatch => ({
  clearComision: () => {
    return dispatch(actions.clearComision());
  },
  getComisionesPagadas: (idEmpleado: number, fechaPago: string) => {
    return dispatch(actions.getComisionesPagadas(idEmpleado, fechaPago));
  }
});
